import axios from 'axios'
import router from "@/router";
import {serverIp} from "../../public/config";
import ElementUI from "element-ui";
import request from "@/utils/request";

const requestDB = axios.create({
    baseURL: serverIp.startsWith("localhost") ? `http://${serverIp}/DB` : `https://${serverIp}/DB`,
    timeout: 100000
})

// requestDB 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
requestDB.interceptors.request.use(config => {
    config.headers['Content-Type'] = 'application/json;charset=utf-8';
    let user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null
    if (user) {
        config.headers['token'] = user.token;  // 设置请求头
    }

    return config
}, error => {
    return Promise.reject(error)
});

// response 拦截器
requestDB.getErrorCode = function (error) {
    switch (error.response.status) {
        case 401:
            ElementUI.Message({
                message: error.response.statusText,
                type: 'error'
            });
            //router.push("/front/home")
            router.push("login")
            return;
        //其他错误码
        default:
            console.log("error", error.response.statusText)
            return;
    }
};
// 可以在接口响应后统一处理结果
requestDB.interceptors.response.use(
    response => {
        let res = response.data;
        // 如果是返回的文件
        if (response.config.responseType === 'blob') {
            return res
        }
        // 兼容服务端返回的字符串数据
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        // 当权限验证不通过的时候给出提示
        if (res.code === '401') {
            ElementUI.Message({
                message: res.msg,
                type: 'error'
            });
            //router.push("/front/home")
            router.push("login")
        }
        return res;
    },
    error => {
        //获取错误码
        requestDB.getErrorCode(error)
        return Promise.reject(error)
    }
)

export default requestDB

